/**
 * Преобразует строковые значения объекта в числа.
 * Удаляет пробелы перед преобразованием.
 * Если передан массив полей — обрабатывает только их. Если нет — обрабатывает все строковые поля.
 * Если значение не удаётся корректно преобразовать в число — оставляет оригинальное.
 *
 * @param {Object} obj - Исходный объект с данными формы.
 * @param {string[]} [fieldsToConvert] - Массив имён полей, которые нужно преобразовать (опционально).
 * @returns {Object} Новый объект с преобразованными значениями.
 */
export function convertStringValuesToNumbers(obj, fieldsToConvert = null) {
  const result = { ...obj };

  for (const key in result) {
    if (!Object.prototype.hasOwnProperty.call(result, key)) continue;

    const shouldConvert = !fieldsToConvert || fieldsToConvert.includes(key);
    const value = result[key];

    if (shouldConvert && typeof value === 'string') {
      const numericString = value.replace(/\s+/g, '');
      const parsedNumber = Number(numericString);

      // Если это валидное число и строка не пустая — сохраняем
      if (!isNaN(parsedNumber) && numericString !== '') {
        result[key] = parsedNumber;
      }
      // иначе — оставляем как есть
    }
  }

  return result;
}
